import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { translate, Trans } from 'react-i18next';
import Map from '../components/Map';
import FormAddress from '../components/FormAddress';
import Loading from '../components/loading/Loading';
import Alert from '../components/Alert/Alert';
import { api } from '../helpers/api';
import { geolocation } from '../helpers/geolocation';

// import PropTypes from 'prop-types';

const STATUS = {
  LOADING: 'loading',
  LOADED: 'loaded',
  NOTFOUND: 'notFound',
};

class Expedition extends Component {
  // static propTypes = {
  // }

  state = {
    status: STATUS.LOADING,
    isGoogleLoaded: false,
    center: undefined,
    markerPosition: undefined,
    address: '',
    found: {},
    formatted_address: '',
    message: undefined,
    showAlert: false,
    typeAlert: undefined,
  }

  componentDidMount() {
    const { hash } = this.props.match.params;
    const { t } = this.props;
    this.checkGoogleLibrary();
    api.findWithHash({ find: { hash } })
      .then(({ data: { found: [found], total } }) => {
        if (total === 0) {
          this.setState({
            status: STATUS.NOTFOUND,
          });
        } else {
          const { location } = found;
          if (location) {
            const { coordinates: [lng, lat] } = location;
            const { street } = found;
            this.setState({
              found,
              address: street,
              status: STATUS.LOADED,
              center: { lat, lng },
              markerPosition: { lat, lng },
            });
          } else {
            const { country, postalCode } = found;
            geolocation.geocoding({
              componentRestrictions: {
                country,
                postalCode,
              },
            }).then(([data]) => {
              const { geometry: { location: { lat, lng } } } = data;
              const { street } = found;
              this.setState({
                showAlert: true,
                address: street,
                message: t('errors.alert', { street }),
                typeAlert: 'danger',
                status: STATUS.LOADED,
                center: { lat: lat(), lng: lng() },
                found,
              });
            }).catch((postalCodeError) => {
              console.error(postalCodeError);
              geolocation.geocoding({
                componentRestrictions: {
                  country,
                },
              }).then(([data]) => {
                const { geometry: { location: { lat, lng } } } = data;
                const { street } = found;
                this.setState({
                  showAlert: true,
                  address: street,
                  message: t('errors.alert', { street }),
                  typeAlert: 'danger',
                  status: STATUS.LOADED,
                  center: { lat: lat(), lng: lng() },
                  found,
                });
              }).catch((countryError) => {
                console.error(countryError);
              });
            });
          }
        }
      }).catch((error) => {
        console.error(error);
      });
  }

  checkGoogleLibrary = () => {
    if (window.google) {
      this.setState({
        isGoogleLoaded: true,
      });
    }
  }

  onSubmit = (dataForm) => {
    const { t } = this.props;
    const { street, country, postalCode } = dataForm;
    this.updatedAddress = dataForm;
    geolocation.geocoding({
      address: street,
      componentRestrictions: {
        country,
        postalCode,
      },
    })
      .then(([data]) => {
        const { geometry: { location: { lat, lng } }, formatted_address } = data;
        this.setState({
          message: formatted_address,
          typeAlert: 'info',
          showAlert: true,
          center: { lat: lat(), lng: lng() },
          markerPosition: { lat: lat(), lng: lng() },
        });
      })
      .catch((error) => {
        this.setState({
          message: t('errors.addressNotFound'),
          typeAlert: 'danger',
          showAlert: true,
        });
      });
  }

  updateAddress = () => {
    const { hash } = this.props.match.params;
    const { t } = this.props;
    const { center } = this.state;
    const updatedData = {
      hash,
      update: {
        location: {
          type: 'Point',
          coordinates: [center.lng, center.lat],
        },
      },
    };
    api.updateWithHash(updatedData)
      .then((result) => {
        this.setState({
          message: t('updated'),
          typeAlert: 'success',
          showAlert: true,
        });
      })
      .catch((error) => {
        console.log('error', error);
      });
  }

  handleMarkerMove = (event) => {
    const lat = event.latLng.lat();
    const lng = event.latLng.lng();
    geolocation.geocoding({ location: { lat, lng } })
      .then(([data]) => {
        console.log('data', data);
        const { geometry: { location: { lat, lng } }, formatted_address } = data;
        this.setState({
          message: formatted_address,
          showAlert: true,
          typeAlert: 'info',
          center: { lat: lat(), lng: lng() },
          markerPosition: { lat: lat(), lng: lng() },
        });
      })
      .catch((error) => {
        console.error('error', error);
      });
  }

  render() {
    const {
      isGoogleLoaded,
      center,
      status,
      markerPosition,
      message,
      showAlert,
      typeAlert,
      address,
    } = this.state;
    const { t } = this.props;
    switch (status) {
      case STATUS.LOADING:
        return <Loading />;
      case STATUS.LOADED:
        return (
          <div className="container widget md:flex-col">
            <img width="100px" src="/images/logoGLS.svg" alt="logo GLS"/>
            <p className="mt-4">
              <Trans i18nKey="info" values={{ address }}>
                <span className="text-blue">{address}</span>
              </Trans>
            </p>
            <div className="flex flex-col md:flex-row mt-4">
              <section id="formAddresse">
                <FormAddress onSubmit={this.onSubmit} initialValues={this.state.found}/>
                <button onClick={this.updateAddress} className="btn btn-action-secondary mt-2">{t('btn.updateAddress')}</button>
                { showAlert
                ? <Alert type={typeAlert} message={message} />
                : null }
              </section>
              <section id="map" className="md:pl-2 mt-4 md:mt-0">
                { !isGoogleLoaded || status.LOADING
                  ? <div>Google Maps is not loaded</div>
                  : <Map
                      center={center}
                      onMarkerMove={this.handleMarkerMove}
                      markerPosition={markerPosition}
                      />
                }
              </section>
            </div>
          </div>
        );
      case STATUS.NOTFOUND:
        return <Redirect to="/404" />;
      default:
        return null;
    }
  }
}

export default translate()(Expedition);



// WEBPACK FOOTER //
// ./src/pages/Expedition.js